import { createFileRoute } from '@tanstack/react-router';
import { PeriodsPage } from '../pages/periods-page';

export const Route = createFileRoute('/periods/')({ component: PeriodsPage });
